import { GroupType, LineType } from '@ardoq/api-types';
import { colors } from '@ardoq/design-tokens';
import { anyType } from '@ardoq/global-consts';

export const PARENT_CHILD_LINE_TYPE = LineType.DOTTED;

export const componentGroupTypes = new Set([
  GroupType.PARENT,
  GroupType.PARENT_ALL,
  GroupType.REFERENCE,
  GroupType.REFERENCE_TYPE_NAME,
]);

export const DEFAULT_EDGE_COLOR_ATTRIBUTES = {
  fill: colors.black950,
  stroke: colors.black950,
};

export const GraphItemConstants = {
  WILDCARD: {
    value: anyType,
    displayLabel: 'Any Type',
  },
} as const;
